import React from 'react'
import ShoppingCartIcon from '@/assets/svg/shopping-cart.svg'
import PaymentIcon from '@/assets/svg/payment.svg'
import TruckIcon from '@/assets/svg/truck.svg'
import MedalIcon from '@/assets/svg/medal.svg'
import { useTranslation } from 'next-i18next'
import StepBar from '@/components/common/StepBar/StepBar'
import { useDeviceType, DeviceType } from '@/utils/hooks/useDeviceType'

type Props = {
  cartActive: boolean
  shippingActive: boolean
  showShipping: boolean
  paymentActive: boolean
  confirmationActive: boolean
  onClick: (name: string) => void
}

const CartStepBar = (props: Props) => {
  const { t } = useTranslation('cart')
  const deviceType = useDeviceType()

  var cartSteps = [
    {
      name: 'cart',
      active: props.cartActive,
      label: t('cart'),
      icon: ShoppingCartIcon
    },
    {
      name: 'delivery',
      active: props.shippingActive,
      label: t('delivery'),
      icon: TruckIcon,
    },
    {
      name: 'payment',
      active: props.paymentActive,
      label: t('payment'),
      icon: PaymentIcon
    },
    {
      name: 'confirmation',
      active: props.confirmationActive,
      label: t('confirmation'),
      icon: MedalIcon
    },
  ]

  if (!props.showShipping) {
    cartSteps = cartSteps.filter(step => step.name !== 'delivery')
  }

  if (deviceType === DeviceType.Mobile) {
    return null
  }

  return (
    <StepBar
      items={cartSteps}
      onClick={props.onClick}
    />
  )
}

export default CartStepBar